module.exports = __webpack_public_path__ + "img/mx.3e55804d.svg";